const CALENDAR_PILL_STYLES = [
    'bg-sky-100 text-sky-900 border border-sky-200',
    'bg-violet-100 text-violet-900 border border-violet-200',
    'bg-orange-100 text-orange-900 border border-orange-200',
] as const;

export function getCalendarPillStyle(index: number): string {
    return CALENDAR_PILL_STYLES[index % CALENDAR_PILL_STYLES.length];
}
